import _slicedToArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
import { mapState } from "vuex";
import FormEditPage from "../../components/FormEditPage";
import CardItem from "@/pages/designCategory/components/CardItem";
import Title from "@/pages/designCategory/components/Title";
import ColorPicker from "@/pages/designCategory/components/ColorPicker";
import FileUpload from "@/pages/designCategory/components/FileUpload";
import InputBar from "@/pages/designCategory/components/InputBar";
import draggable from "vuedraggable";
import { initLang } from "@/pages/designCategory/tools/utils";
export default {
  i18n: require('../../../design/design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    Title: Title,
    ColorPicker: ColorPicker,
    FileUpload: FileUpload,
    InputBar: InputBar,
    draggable: draggable
  },
  data: function data() {
    return {
      titleShow: false,
      listShow: false,
      listItemShow: false,
      form: this.$form.createForm(this),
      rightIndex: 0,
      // 右侧选择的index
      defaultLangId: '',
      curListItemIndex: 0
    };
  },
  created: function created() {
    var defaultLangObj = localStorage.defaultLangObj;
    if (defaultLangObj) {
      defaultLangObj = JSON.parse(defaultLangObj);
      this.defaultLangId = defaultLangObj.langId;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    rightCom: function rightCom(state) {
      return state.designCategory.select_right_com;
    },
    rightId: function rightId(state) {
      return state.designCategory.select_right_id;
    },
    imgHost: function imgHost(state) {
      return state.designCategory.imgHost;
    }
  })), {}, {
    list: function list() {
      if (!this.rightCom.list[this.curListItemIndex].image) return [];
      return [this.imgHost + this.rightCom.list[this.curListItemIndex].image];
    }
  }),
  watch: {
    rightId: function rightId() {
      // 判断是不是当前选中的aside 是就显示
      if (!this.rightId) {
        this.show = false;
        return;
      }
      var _this$rightId$split = this.rightId.split("-"),
        _this$rightId$split2 = _slicedToArray(_this$rightId$split, 2),
        asideId = _this$rightId$split2[0],
        rightId = _this$rightId$split2[1];
      asideId = parseInt(asideId);
      // rightId = parseInt(rightId)

      if (this.value.id !== asideId) return;
      rightId = parseInt(rightId);
      if (this.rightCom.type === 'title') {
        this.listShow = false;
        this.listItemShow = false;
        this.titleShow = true;
      } else if (this.rightCom.type === 'list') {
        this.titleShow = false;
        this.listShow = true;
      }
    }
  },
  methods: {
    handleDeleteList: function handleDeleteList() {
      if (this.rightCom.list[this.curListItemIndex]) {
        this.rightCom.list.splice(this.curListItemIndex, 1);
      }
    },
    handleDeleteListItem: function handleDeleteListItem(i) {
      if (this.rightCom.list[i]) {
        this.rightCom.list.splice(i, 1);
      }
    },
    handleListItemClick: function handleListItemClick(item, i) {
      this.curListItemIndex = i;
      this.listItemShow = true;
    },
    handleAddListItem: function handleAddListItem() {
      var obj = {
        "title": {},
        "image": "",
        "link": ""
      };
      initLang(obj.title, "默认菜单");
      this.rightCom.list.push(obj);
    },
    handleImg: function handleImg() {
      this.rightCom.list[this.curListItemIndex].image = '';
    },
    handleImgSuccess: function handleImgSuccess(val) {
      this.rightCom.list[this.curListItemIndex].image = val;
    }
  }
};